import './ViewerPanel.scss';

export { default as ViewerPanel } from './ViewerPanel';
export {
  getPushPinSchema,
  pushPinUiSchema,
  getViewerPanelSchema,
  viewerPanelUiSchema,
} from './viewerPanelSchema';
